import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';

import {
  Container,
  DeletableContainersResponse,
  Entity,
  Rollable,
  RollContainerInfo,
  RollContainerPayload
} from '../models';
import { ListResponse, ObjectResponse } from '../interfaces';
import { AppConfig } from './app-config';

@Injectable()
export class ContainersService extends BaseService<Container> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  // TODO: override, remove when all responses refactored and base updated
  public list(): Observable<ListResponse<Container>> {
    return this.http.get<ListResponse<Container>>(`${this.getPrincipleUrl()}container`);
  }

  // TODO: override, remove when all responses refactored and base updated
  public put(model: any): Observable<ObjectResponse<Entity>> {
    return this.http.put<ObjectResponse<Entity>>(`${this.getPrincipleUrl()}user`, model);
  }

  public getWorkingContainerEntity(): Observable<ObjectResponse<Entity>> {
    const apiUrl = this.applyQueryString('workingContainer');

    return this.http.get<ObjectResponse<Entity>>(apiUrl);
  }

  rollContainer(rollInfo: RollContainerInfo): Observable<ObjectResponse<RollContainerInfo>> {
    const existingContainerId: number = rollInfo.containerId;
    const newTaxYear: number = rollInfo.taxYear;

    const body: RollContainerPayload = { existingContainerId, newTaxYear };

    const url = `${this.getPrincipleUrl()}container/roll/${existingContainerId}`;
    return this.http.post<ObjectResponse<any>>(url, body);
  }

  getIsRollable(containerId: number): Observable<ObjectResponse<Rollable>> {
    const url = `${this.getPrincipleUrl()}container/rollable/${containerId}`;
    return this.http.get<ObjectResponse<Rollable>>(url);
  }

  getDeletableContainers(containerId: number): Observable<ObjectResponse<DeletableContainersResponse>> {
    const url = `${this.getPrincipleUrl()}container/deletable/${containerId}`;
    return this.http.get<ObjectResponse<DeletableContainersResponse>>(url);
  }

  deleteContainer(rollInfo: RollContainerInfo): Observable<ObjectResponse<any>> {
    const existingContainerId: number = rollInfo.containerId;

    const url = `${this.getPrincipleUrl()}container/${existingContainerId}`;
    return this.http.delete<ObjectResponse<any>>(url);
  }

  protected getResourceUrl(): string {
    return `${this.config.getBaseApiUrl()}containers/`;
  }
  protected getPrincipleUrl(): string {
    return this.config.getPrincipleUrl();
  }
}
